export const width = 420;
export const height = 384;
export default __webpack_public_path__ + "static/report-rafiki.2fe88837.svg";